import React from "react";
import { Package, PauseCircle } from "lucide-react";
import AdminCrudPage from "./AdminCrudPage";
import { apiGet, apiPost, apiPut } from "./adminApi";

const fields = [
  {
    name: "id",
    label: "Product ID",
    type: "number",
    min: 1,
    createOnly: true,
    help: "Leave empty to assign the next available id automatically.",
  },
  { name: "productName", label: "Product Name", type: "text", required: true, placeholder: "e.g. Bursary & Loan" },
  { name: "organization", label: "Organization", type: "text", placeholder: "e.g. HEC" },
  { name: "productDescription", label: "Description", type: "textarea", placeholder: "What this product covers" },
  {
    name: "isOnhold",
    label: "Status",
    type: "checkbox",
    checkboxLabel: "Product is on hold (not currently offered)",
    fullWidth: true,
  },
];

export default function ProductsPage() {
  return (
    <AdminCrudPage
      title="Products"
      subtitle="Bursary and loan products that qualifications are attached to"
      icon={Package}
      entityName="product"
      queryKey="adminProducts"
      fetchAll={() => apiGet("hec/products/all")}
      createItem={(values) => apiPost("hec/products/create", { ...values, id: values.id || 0 })}
      updateItem={(id, values) => apiPut(`hec/products/${id}`, values)}
      getId={(row) => row.id}
      searchKeys={["productName", "productDescription", "organization"]}
      columns={[
        { key: "id", label: "ID", render: (r) => <span className="font-mono text-gray-600">{r.id}</span> },
        { key: "productName", label: "Product", render: (r) => <span className="font-semibold text-gray-900">{r.productName}</span> },
        { key: "organization", label: "Organization" },
        { key: "productDescription", label: "Description", cellClassName: "max-w-md truncate" },
        {
          key: "isOnhold",
          label: "Status",
          render: (r) =>
            r.isOnhold ? (
              <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium bg-amber-50 text-amber-700 border border-amber-200">
                <PauseCircle className="w-3 h-3" /> On hold
              </span>
            ) : (
              <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200">
                Active
              </span>
            ),
        },
      ]}
      fields={fields}
      extraStats={[
        { icon: PauseCircle, label: "On hold", tone: "amber", value: (rows) => rows.filter((r) => r.isOnhold).length },
      ]}
      emptyHint="Create a product, then attach qualifications to it from Product Qualifications."
    />
  );
}
